import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { routingConstants } from '../_constants/routing-constants.const';

export const AnonymousGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  if (msalService.instance.getAllAccounts().length > 0) {
    return router.createUrlTree([routingConstants.transcriber]);
  }

  return true;
};
